// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class header {
  constructor () {

    this.$mobileNavButton     = $(".mobile-btn") 
    this.$closeMobileButton   = $(".close-mobile-nav")
    this.$mobileNavBg         = $(".mobile-nav-bg-curtain")
    this.$siteHeader          = $(".header-primary")
    this.$megaMenuList        = $('.mega-menu')
    this.$megaMenu            = $('.mega-menu > span')
    //this.$megaMenu            = $('.arrow')
    this.$megaMenuDropdown     = $('.mega-menu > a')
    this.moveArrowSpan()
    this.mouseEventHandler()

    this.$mobileNavButton.click(function () { 
      $(".navigation").addClass('menu-open')
      $(".mobile-nav-bg-curtain").addClass('menu-open')
    }); 

    this.$closeMobileButton.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    }); 

    this.$mobileNavBg.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    });

    this.$megaMenu.on('click', (event) => {
      event.preventDefault()  
      console.log('clicked')
      $(event.currentTarget).next('.submenu-wrapper').toggleClass('show');
      $(".header-primary").toggleClass('dark-bg')
    })

    // const mouseenterHandler = (event) => {
    //   event.stopPropagation();
    //   $(event.currentTarget).siblings('.submenu-wrapper').fadeIn('slow');
    //   $(".header-primary").addClass('dark-bg');
    // };

    // this.$megaMenuDropdown.on('mouseenter', mouseenterHandler);
    // this.$megaMenu.on('mouseenter', mouseenterHandler);



    this.$megaMenuDropdown.siblings('.submenu-wrapper').on('click', (event) =>{ 
      event.stopPropagation();
    })

    this.$megaMenuDropdown.siblings('.submenu-wrapper').on('mouseenter', (event) =>{ 
      event.stopPropagation();
    })

    $('html, body').on('mouseover touchend', (e) => {
      var container = $('.submenu-wrapper');
      var isHeaderPrimary = $(e.target).closest('.header-primary').length > 0;
      var isSubmenuWrapper = $(e.target).closest('.submenu-wrapper').length > 0;

      if (!isHeaderPrimary && !isSubmenuWrapper) {
        container.fadeOut('slow');
        $(".header-primary").removeClass('dark-bg');
      }
    });

    function is_touch_enabled() {
    return ( 'ontouchstart' in window ) || 
      ( navigator.maxTouchPoints > 0 ) || 
      ( navigator.msMaxTouchPoints > 0 );
    }

    if( is_touch_enabled() ) {
      $('html').addClass('is-touch');
    }

  }

  mouseEventHandler() {
    var windowWidth = $(window).width();
    const submenuWrapper = $('.submenu-wrapper');
    const mouseenterHandler = (event) => {
      event.stopPropagation();
      $(event.currentTarget).siblings('.submenu-wrapper').fadeIn('slow');
      $(".header-primary").addClass('dark-bg');
    };

    this.$megaMenuDropdown.on('mouseenter', mouseenterHandler);
      this.$megaMenu.on('mouseenter', mouseenterHandler);
      submenuWrapper.removeAttr('style');
  }

  moveArrowSpan() {

    var windowWidth = $(window).width();

    if (windowWidth < 1024) {
      // Move the span.arrow element outside the anchor on mobile
      $('ul.menu li.menu-item-has-children').each(function() {
        var menuItem = $(this);
        var anchor = menuItem.find('> a');
        var arrow = menuItem.find('span.arrow');

        // Remove any existing arrow elements inside the anchor
        anchor.find('span.arrow').remove();

        // Append the arrow afer the anchor
        anchor.after(arrow);

        // Re-bind click event to the arrow in mobile view
        arrow.on('click', (event) => {
          event.preventDefault();
          console.log('clicked');
          $(event.currentTarget).next('.submenu-wrapper').toggleClass('show');
          $(".header-primary").toggleClass('dark-bg');
        });
      });
    } else {
      // Move the span.arrow element inside the anchor on desktop
      $('ul.menu li.menu-item-has-children').each(function() {
        var menuItem = $(this);
        var anchor = menuItem.find('> a');
        var arrow = menuItem.find('span.arrow');

        // Remove any existing arrow elements outside the anchor
        menuItem.find('span.arrow').remove();

        // Append the arrow inside the anchor
        anchor.append(arrow);

        // Remove click event from arrow in desktop view
        arrow.off('click');
      });
    }
  }


  onWindowScroll (scrollTop) {
    if (scrollTop >= 20) {
      this.$siteHeader.addClass('js-fixed-header')
    } else {
      this.$siteHeader.removeClass('js-fixed-header')
    }
  }

  onWindowResize () {
    this.moveArrowSpan()
    this.mouseEventHandler()
  }

}

export default header


// WEBPACK FOOTER //
// ./src/js/shg/header/header.js